module.exports = __webpack_public_path__ + "static/media/1POLICY14.60903cd8.jpg";